import { composeButtonComponentWithStyle } from './Button';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { ComponentStyles } = StyleLibrary;

export const TertiaryButton = composeButtonComponentWithStyle(ComponentStyles.ButtonStyles.tertiaryButton);
